<template>
	<div>
		
		<layout>

			<template v-slot:title> 
				MIS ENVÍOS
			</template>

			<template v-slot:subtitle> 
				MIS ENVÍOS
			</template>


			<template v-slot:content>

				<div id="cms-clientes">
					
					<v-container>

						<v-card light v-if="sends != null">

					    <v-card-title>
					      <v-text-field
					        v-model="search"
					        append-icon="mdi-magnify"
					        label="Buscar"
					        single-line
					        hide-details
					      ></v-text-field>
					    </v-card-title>
					    
					    <v-data-table
					      :headers="headers"
					      :items="sends"
					      :search="search"
					    >

						    <template v-slot:item.created_at="{ item }">
						    	{{datetimeFormat2(item.created_at)}}
					    	</template>

					    	<template v-slot:item.packages.logo="{ item }">
						    	<img src="@/assets/img/redpack.png" height="25">
						    	<small v-if="item.packages_id == 1"><b>EXPRESS</b></small>
						    	<small v-else><b>ECOEXPRESS</b></small>
					    	</template>
					    	

					    	<template v-slot:item.options="{ item }">

					    		<v-btn 
					    			class="me-3 mb-3 mt-3" 
					    			color="primary"
					    			small
					    			@click="showSend(item.id)"
					    		>
					    			<v-icon class="me-1" small>mdi-eye</v-icon>
					    			Ver envío
					    		</v-btn>


					    		<v-btn 
					    			v-if="item.status == 'ESPERANDO_PAGO'"
					    			color="primary"
					    			small
					    			disabled=""
					    		>
					    			<v-icon class="me-1" small>mdi-file-download</v-icon>
					    			Descargar guía 

					    			<small style="position: absolute;top: 22px;color: black !important;">
					    				(Pago en verificación)
					    			</small>

					    		</v-btn>


					    		<v-btn 
					    			v-else
					    			color="primary"
					    			small
					    			@click="downloadGuide(item.guide)"
					    		>
					    			<v-icon class="me-1" small>mdi-file-download</v-icon>
					    			Descargar guía 

					    		</v-btn>

					    	
					    	</template>


					    </v-data-table>
					  </v-card>
					</v-container>




					<!-- file send -->
					<v-dialog
						light
			      v-model="showFileSend"
			      persistent
			      max-width="600px"
			      style="z-index: 2000;"
			    >
			      <v-card  v-if="send != null">
			        
			        <v-card-title>
			          <span class="text-h6">Numero de seguimiento: {{send.code}}</span>
			          
			          <v-btn
                  icon
                  @click="showFileSend = false"
                  style="position: absolute;right: 0px;"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>

			        </v-card-title>


			        <v-card-text>
			          <v-container>         

			          	<img src="@/assets/img/redpack.png" height="30px" />
			          	<small v-if="send.packages_id == 1"><b>EXPRESS</b></small>
			          	<small v-else><b>ECOEXPRESS</b></small>

			          	<!-- status -->
			          	<h4>ESTADO: 
			          		<b style="color: #404040" v-if="send.status != 'SIN_GENERACION_GUIA'">{{send.status}}</b>
			          		<b style="color: #404040" v-else>PAGO EN VERIFICACIÓN</b>
			          	</h4>

			          	<p>Fecha: {{datetimeFormat2(send.created_at)}}</p>

			          	
			          	<!-- cliente -->
			          	<div class="mt-10">
			          		<h4>CLIENTE</h4>
			          		<v-row class="mb-0 mt-1">
			          			<v-col lg="6">
			          				<p class="mb-0"><b>Nombre:</b></p>
			          				<p class="mb-0">{{send.customer.name}}</p>
			          			</v-col>
			          			<v-col lg="6">
			          				<p class="mb-0"><b>Teléfono:</b></p>
			          				<p class="mb-0">{{phoneFormat(send.customer.phone)}}</p>
			          			</v-col>
			          		</v-row>
			          		<v-row style="margin-top: -15px;">
			          			<v-col lg="6">
			          				<p class="mb-0"><b>Correo electrónico:</b></p>
			          				<p class="mb-0">{{send.customer.user.email}}</p>
			          			</v-col>
			          			<v-col lg="6">
			          				<p class="mb-0"><b>Negocio:</b></p>
			          				<p class="mb-0">{{send.customer.name_business}}</p>
			          			</v-col>
			          		</v-row>
			          	</div>


			          	<!-- parcel -->
			          	<div class="mt-10">
			          		<h4>PAQUETE</h4>
			          		<v-row class="mt-1">
			          			<v-col lg="3">
			          				<p class="mb-0"><b>Peso:</b></p>
			          				<p class="mb-0">{{send.send_package.peso}} KG.</p>
			          			</v-col>
			          			<v-col lg="3">
			          				<p class="mb-0"><b>Largo:</b></p>
			          				<p class="mb-0">{{send.send_package.largo}} CM.</p>
			          			</v-col>
			          			<v-col lg="3">
			          				<p class="mb-0"><b>Ancho:</b></p>
			          				<p class="mb-0">{{send.send_package.ancho}} CM.</p>
			          			</v-col>
			          			<v-col lg="3">
			          				<p class="mb-0"><b>Alto:</b></p>
			          				<p class="mb-0">{{send.send_package.alto}} CM.</p>
			          			</v-col>
			          		</v-row>
	          				<p class="mb-0 mt-2"><b>Contenido:</b></p>
	          				<p class="mb-0">{{send.send_package.content}}</p>
			          	</div>



			          	<!-- address -->
			          	<div class="mt-10">
			          		<v-row>

			          			<v-col lg="6">
					          		<h4>DIRECCIÓN DE ORIGEN</h4>
			          				<p class="mb-0 mt-4"><b>Código postal:</b></p>
			          				<p class="mb-0">{{send.origin.postal_code}}</p>
			          				<p class="mb-0 mt-2"><b>Contacto:</b></p>
			          				<p class="mb-0">{{send.origin.contact}}</p>
			          				<p class="mb-0 mt-2"><b>Calle:</b></p>
			          				<p class="mb-0">{{send.origin.street}}</p>
			          				<p class="mb-0 mt-2"><b>Referencia:</b></p>
			          				<p class="mb-0">{{send.origin.reference}}</p>
			          				<p class="mb-0 mt-2"><b>Negocio:</b></p>
			          				<p class="mb-0">{{send.origin.business}}</p>
			          				<p class="mb-0 mt-2"><b>Colonia:</b></p>
			          				<p class="mb-0">{{send.origin.neighborhood}}</p>
			          				<p class="mb-0 mt-2"><b>Estado:</b></p>
			          				<p class="mb-0">{{send.origin.state}}</p>
			          				<p class="mb-0 mt-2"><b>Ciudad:</b></p>
			          				<p class="mb-0">{{send.origin.city}}</p>
			          				<p class="mb-0 mt-2"><b>Teléfono:</b></p>
			          				<p class="mb-0">{{phoneFormat(send.origin.phone)}}</p>
			          			</v-col>

			          			<v-col lg="6">
					          		<h4>DIRECCIÓN DE DESTINO</h4>
			          				<p class="mb-0 mt-4"><b>Código postal:</b></p>
			          				<p class="mb-0">{{send.destination.postal_code}}</p>
			          				<p class="mb-0 mt-2"><b>Contacto:</b></p>
			          				<p class="mb-0">{{send.destination.contact}}</p>
			          				<p class="mb-0 mt-2"><b>Calle:</b></p>
			          				<p class="mb-0">{{send.destination.street}}</p>
			          				<p class="mb-0 mt-2"><b>Referencia:</b></p>
			          				<p class="mb-0">{{send.destination.reference}}</p>
			          				<p class="mb-0 mt-2"><b>Negocio:</b></p>
			          				<p class="mb-0">{{send.destination.business}}</p>
			          				<p class="mb-0 mt-2"><b>Colonia:</b></p>
			          				<p class="mb-0">{{send.destination.neighborhood}}</p>
			          				<p class="mb-0 mt-2"><b>Estado:</b></p>
			          				<p class="mb-0">{{send.destination.state}}</p>
			          				<p class="mb-0 mt-2"><b>Ciudad:</b></p>
			          				<p class="mb-0">{{send.destination.city}}</p>
			          				<p class="mb-0 mt-2"><b>Teléfono:</b></p>
			          				<p class="mb-0">{{phoneFormat(send.destination.phone)}}</p>
			          			</v-col>

			          		</v-row>
			          	</div>



			          	<!-- payment -->
			          	<div class="mt-10">
			          		<h4>PAGO</h4>
			          		<v-row class="mt-1">
			          			<v-col lg="6">
			          				<p class="mb-0"><b>Método de pago:</b></p>
			          				<p class="mb-0">
			          					<span v-if="send.send_payment.method == 'bank-deposit'">DEPOSITO BANCARIO</span>
			          					<span v-else-if="send.send_payment.method == 'paypal'">PAYPAL</span>
			          					<span v-else-if="send.send_payment.method == 'credit-card'">TARJETA</span>
			          				</p>
			          			</v-col>
			          			<v-col md="6" cols="12">
		          					

		          					<p class="mb-0" v-if="send.send_payment.method == 'bank-deposit'"><b>Comprobante:</b></p>
			          				<p class="mb-0" v-else><b>Referencia:</b></p>


			          				<div class="mb-0" v-if="send.send_payment.method == 'bank-deposit'">
			          					<a :href="backend+'../storage/app/'+send.send_payment.reference" target="_blank">
			          						<img :src="backend+'../storage/app/'+send.send_payment.reference" width="150" />
			          					</a>
			          				</div>

			          				<div class="mb-0" v-else>
			          					<p>{{send.send_payment.reference}}</p>
			          				</div>


			          			</v-col>
			          		</v-row>

			          	</div>


			          	<!-- btn download guide -->
			          	<div class="text-center mt-10">

			          		<v-btn 
			          			v-if="send.status_payment == 'ESPERANDO_PAGO'"
			          			color="primary" 
			          			disabled=""
			          		>
			          			<v-icon>mdi-file-download</v-icon> DESCARGAR GUÍA
			          		</v-btn>

			          		<v-btn 
			          			v-else
			          			color="primary"
			          			@click="downloadGuide(send.guide)"
			          		>
			          			<v-icon>mdi-file-download</v-icon> DESCARGAR GUÍA
			          		</v-btn>

			          	</div>
			          	

			          </v-container>
			        </v-card-text>


			      </v-card>
			    </v-dialog>
			    <!--/ file send -->




				</div>

		  </template>
		</layout>

	</div>
</template>


<script>
	
	import Layout from './../../layout/Layout'
	import UserService from '@/shared/services/UserService'
	import SendService from '@/shared/services/SendService'


	export default
	{

		data() {
			return {
				search: '',
        headers: [
          { text: 'Fecha', align: 'start', value: 'created_at', sortable: false },
          { text: 'Numero de seguimiento', value: 'code', filterable: true },
          { text: 'Código postal de origen', value: 'origin.postal_code' },
          { text: 'Código postal de destino', value: 'destination.postal_code' },
          { text: 'Paquetería', value: 'packages.logo', sortable: false },
          { text: 'Opciones', value: 'options', sortable: false },
        ],

        sends: null,
        send: null,

        showFileSend: false
			}
		},

		components: {
			Layout
		},

		created() {
			this.getSends()
		},

		methods: {

			async getSends()
			{
				const resp = await UserService.getUser()
				let user_id = resp.data.id

				const resp2 = await SendService.getByUser(user_id)
				this.sends = resp2.data
			},

			async downloadGuide(guide)
			{
				let link = document.createElement("a");
				link.href = "data:application/pdf;base64,"+guide;
				link.download = "Guia.pdf";
				link.click();
				link.remove();
			},

			async showSend(id)
			{
				const resp = await SendService.getOne(id)
				
				this.send = resp.data

				this.showFileSend = true
			}

		}

	}

</script>